// extracted by css-extract-rspack-plugin
export default {"flexContainer":"MaskTabs_flexContainer__sOYEB"};